// A no-operation function to use when you want to do nothing
export default function () {}
